import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery} from './api-utils';
import {
  AmountHistory,
  AmountHistoryRequest,
  AmountHistoryResponse,
  CardDetailsRequest,
  CardLastMovementsRequest,
  CardMovementsRequest,
  CardMovementsResponse,
  ContractDetailsRequest,
  CreditCardDetails,
  CreditCardPeriodList,
  FamiliesRequest,
  Family,
  FamilyList,
  MovementsList,
  MovementsRequest
} from '../@types/ContractInfoTypes';

const URL_API = '/business_webcustsyn/rest';

export const getPrintRibUrl = (primaryContractId: string, contractReference: string, language: string) =>
    `${URL_API}/contract/rib/print?primaryContract=${primaryContractId}&reference=${contractReference}&lg=${language}`;

export const customerSynthesisApi = createApi({
  reducerPath: 'customerSynthesisApi',
  baseQuery: axiosBaseQuery({
    baseUrl: URL_API
  }),
  tagTypes: ['Synthesis'],

  endpoints: (builder) => ({
    getFamilies: builder.query<Array<Family>, FamiliesRequest>({
      query: (request) => ({
        url: '/families/get',
        method: 'POST',
        data: request
      }),
      providesTags: [{type: 'Synthesis', id: 'Families'}],
      transformResponse: (response: FamilyList) => response.familyList
    }),
    getMovements: builder.query<MovementsList, MovementsRequest>({
      query: (request) => ({
        url: '/movements/account/get',
        method: 'POST',
        data: request
      })
    }),
    getAmountHistory: builder.query<AmountHistory[], AmountHistoryRequest>({
      query: (request) => ({
        url: '/contract/balance/history/get',
        method: 'POST',
        data: request
      }),
      transformResponse: (response: AmountHistoryResponse) => response.amountHistoryList
    }),
    details: builder.query<any, ContractDetailsRequest>({
      query: (request) => ({
        url: '/contract/details/' + request.urlEnd?.toLowerCase() + '/get',
        method: 'POST',
        data: request.data
      })
    }),
    getCardDetails: builder.query<CreditCardDetails, CardDetailsRequest>({
      query: (request) => ({
        url: '/contract/details/card/get',
        method: 'POST',
        data: request.data
      }),
        providesTags: [{type: 'Synthesis', id: 'CardDetails'}]
    }),
    getCardMovements: builder.query<CardMovementsResponse, CardMovementsRequest>({
      query: (request) => ({
        url: '/cards/movements/list',
        method: 'POST',
        data: request
      })
    }),
    getLastCardMovements: builder.query<CardMovementsResponse, CardLastMovementsRequest>({
      query: (request) => ({
        url: '/cards/movements/last',
        method: 'POST',
        data: request
      })
    }),
    getCardPeriods: builder.query<CreditCardPeriodList, void>({
      query: (request) => ({
        url: '/cards/periods/list',
        method: 'POST'
      })
    })
    /*,
    getCreditCardPeriods: builder.query<CreditCardPeriod[], { addAllPeriod: boolean, label: string }>({
        query: (request) => ({
            url: '/cards/periods/list',
            method: 'POST'
        }),
        keepUnusedDataFor: 60,
        transformResponse: (response: CreditCardPeriodList, meta, arg) => {
            const periods = response.creditCardPeriodList;
            const {addAllPeriod, label} = arg ?? {};
            if (addAllPeriod) {
                periods.push({
                    endDate: response.creditCardPeriodList[0].endDate,
                    label: label,
                    startDate: response.creditCardPeriodList[response.creditCardPeriodList.length - 1].startDate,
                    withdrawalDate: ''
                });
            }
            return periods;
        }
    }),
    getCreditCardMovements: builder.query<CreditCardMovement[], GetCreditCardMovementsRequest>({
        query: (request) => ({
            url: '/cards/movements/list',
            method: 'POST',
            data: request
        }),
        keepUnusedDataFor: 60,
        transformResponse: (response: CreditCardMovementList) => response.creditCardMovementList
    }),
    printAllCreditCardsMovements: builder.query<CreditCardMovement[], GetCreditCardMovementsRequest>({
        query: (request) => ({
            url: '/creditCards/synthesis/print',
            method: 'GET',
            data: request
        })
    })*/
  })
});

export const {
  useGetFamiliesQuery,
  useGetMovementsQuery,
  useGetAmountHistoryQuery,
  useDetailsQuery,
  useGetCardDetailsQuery,
  useGetCardMovementsQuery,
  useGetCardPeriodsQuery,
} = customerSynthesisApi;
